import { BoxProps, DrawerFooter, HStack } from '../../../atoms';

export function SideOverlayFooter(props: BoxProps): JSX.Element {
  return (
    <DrawerFooter
      as={HStack}
      gap="space_unit.x1"
      flexShrink={0}
      borderTopColor="palette_gray.10"
      borderTopStyle="solid"
      borderTopWidth="1px"
      {...props}
    />
  );
}
